<template>

  <div>

    <list-filters
      :trigger-filter.sync="triggerFilter"
      :data-filter.sync="dataFilter"
    />

    <generate-nomor
      :trigger-filter.sync="triggerFilter"
      :data-filter.sync="dataFilter"
      @reload="refetchData"
      v-if="$can('create', 'surat-tugas')"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Tampilkan</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entri</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <h6 class="mr-1">Lihat Data Filter</h6>
              <v-select
                v-model="searchQuery"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="lihatSebagaiOptions.options"
                class="w-50"
                :reduce="val => val.value"
                :clearable="false"
                placeholder="Lihat Sebagai"
              />
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchDatas"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Tidak ada data yang ditemukan"
        :sort-desc.sync="isSortDirDesc"
        style="text-align:center;"
      >

        <!-- Column: User -->
        <template #cell(status_jadwal)="data">
          <b-media vertical-align="center">
              <b-badge pill :variant="'light-'+data.item.color" >{{ data.item.status_jadwal }}</b-badge>
          </b-media>
        </template>

        <template #cell(link_zoom)="data">
            <div class="d-flex justify-content-center">
               <b-button class="mr-1 btn-icon btn btn-relief-primary" variant="primary" target="_blank" :href="data.item.link_zoom"
            >
              <feather-icon icon="GlobeIcon" />
            </b-button>
            </div>
        </template>

        <template #cell(dosen_sidang)="data">
            <div class="d-flex justify-content-center">
               <b-button v-b-modal="'modal-center'+data.item.id" size="md" variant="success">Lihat</b-button>
                <b-modal :id="'modal-center'+data.item.id" centered title="">
                  <h5>Dosen Pembimbing</h5>
                  <div v-for="(item, index) in data.item.dosen_pembimbing" :key="'dpem'+index">
                    <label for="" v-if="item.pembimbing_utama !== 3">Dosen Pembimbing {{index += 1}}</label>
                    <label for="" v-if="item.pembimbing_utama === 3">Dosen Pembimbing Akademik</label>
                    <b-form-input :value="item.nama" readonly class="mb-2"/>
                  </div>
                  <h5 class="mt-3">Dosen Penguji</h5>
                  <div v-for="(item, index) in data.item.dosen_penguji" :key="'dpeng'+index">
                    <label for="">Dosen Penguji {{index += 1}}</label>
                    <b-form-input :value="item.nama" readonly class="mb-2"/>
                  </div>
                </b-modal>
            </div>
        </template>

        <!-- Column: Actions -->
        <template #cell(dokumen)="data">
          <div class="d-flex justify-content-center">
            <b-button class="mr-1 btn-icon btn btn-relief-primary" variant="primary" title="Lihat Data" v-if="data.item.file != null" @click="lihatDokumen(data.item.file)"
            >
              <feather-icon icon="DownloadIcon" />
            </b-button>
          </div>
        </template>

        <!-- Column: Generate -->
        <template #cell(actions)="data">
          <div class="d-flex justify-content-center">
            <b-button 
              class="mr-1 btn-icon btn btn-relief-success" 
              variant="success" 
              title="Generate Surat Tugas" 
              @click="openModalGenerate(data.item)"
              :disabled="isGenerating"
            >
              <feather-icon icon="FileTextIcon" />
            </b-button>
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Tampilkan {{ dataMeta.from }} hingga {{ dataMeta.to }} dari {{ dataMeta.of }} entri</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>

    <!-- Modal Generate Surat Tugas -->
    <b-modal
      id="modal-generate-surat-tugas"
      v-model="showModalGenerate"
      title="Generate Surat Tugas"
      ok-title="Generate"
      cancel-title="Batal"
      @ok="handleModalOk"
      @cancel="closeModalGenerate"
      @hide="closeModalGenerate"
    >
      <b-form-group label="Nomor Surat" label-for="nomor-surat">
        <b-form-input
          id="nomor-surat"
          v-model="nomorSurat"
          placeholder="Masukkan nomor surat (contoh: 001)"
          type="text"
          required
        />
        <small class="text-muted">
          Format akan menjadi: ST-{nomor}/UN2.F8.D/SDM.05.06/{tahun}
        </small>
      </b-form-group>
      <b-form-group label="Tanggal Terbit ST" label-for="tanggal-terbit">
        <b-form-datepicker
          id="tanggal-terbit"
          v-model="tanggalTerbit"
          placeholder="Pilih Tanggal Terbit (Default: Tanggal Ujian)"
          class="mb-1"
          locale="id"
        />
      </b-form-group>
      <b-form-group v-if="selectedItem" label="Detail" label-for="detail">
        <small class="text-muted">
          <div><strong>Jenis:</strong> {{ selectedItem.jenis }}</div>
          <div><strong>Nama:</strong> {{ selectedItem.name }}</div>
          <div><strong>NPM:</strong> {{ selectedItem.npm }}</div>
        </small>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BModal, BFormGroup, BFormDatepicker,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  postMulaiSidang,
  downloadSuratTugas,
  generateSuratTugas,
} from '@/connection-api/master'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { avatarText } from '@core/utils/filter'
import storeModule from '@/connection-api/surat-tugas/storeModule'
import useList from '@/connection-api/surat-tugas/list'
import listFilters from './ListFilters.vue'
import generateNomor from './GenerateNomor.vue'

export default {
  components: {
    listFilters,
    generateNomor,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    // BLink,
    BDropdown,
    BDropdownItem,
    BPagination,
    BBadge,
    BModal,
    BFormGroup,
    BFormDatepicker,

    vSelect,
  },
  data() {
    return {
      isGenerating: false,
      showModalGenerate: false,
      selectedItem: null,
      nomorSurat: '',
      tanggalTerbit: null,
      attr: null,
      jenisUptOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis UPT --' },
        ],
      },
      kanwilOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis Kanwil --' },
        ],
      },
      uptOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih UPT --' },
        ],
      },
      jenisAssetOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis Asset --' },
        ],
      },
      statusAssetOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Status Asset --' },
        ],
      },
      lihatSebagaiOptions: {
        selected: 'id',
        options: [
          { value: 'penguji', label: 'Penguji' },
        ],
      },
    }
  },
  async mounted() {
    this.searchQuery = 'penguji';
    const userDataString = localStorage.getItem('userData')
    const userDataArray = JSON.parse(userDataString)
    this.attr = userDataArray.attr
  },
  methods: {
    async lihatDokumen(filename) {
      downloadSuratTugas(filename)
          .then(resp => {
            var type_file = filename.substring(filename.length - 4);
            if (type_file === ".pdf") {
              const fileURL = window.URL.createObjectURL(new Blob([resp.data]))
              const fileLink = document.createElement('a')

              fileLink.href = fileURL
              fileLink.setAttribute('download', filename)
              document.body.appendChild(fileLink)
              fileLink.click()
            }
          })
          .catch(error => {
          this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Hasil Sidang',
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: 'Gagal Membuat File',
              },
            })
        });
    },
    openModalGenerate(item) {
      if (!item.uuid) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Surat Tugas',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: 'UUID tidak ditemukan',
          },
        })
        return
      }
      this.selectedItem = item
      this.nomorSurat = item.nomor_surat ? this.extractNomorSurat(item.nomor_surat) : ''
      this.tanggalTerbit = null
      this.showModalGenerate = true
    },
    closeModalGenerate() {
      this.showModalGenerate = false
      this.selectedItem = null
      this.nomorSurat = ''
      this.tanggalTerbit = null
    },
    handleModalOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.generateSuratTugasHandler()
    },
    extractNomorSurat(nomorSuratFull) {
      // Extract nomor dari format "ST-001/UN2.F8.D/SDM.05.06/2024"
      const match = nomorSuratFull.match(/ST-(\d+)\//)
      return match ? match[1] : ''
    },
    async generateSuratTugasHandler() {
      if (!this.selectedItem || !this.selectedItem.uuid) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Surat Tugas',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: 'UUID tidak ditemukan',
          },
        })
        return
      }

      if (!this.nomorSurat || this.nomorSurat.trim() === '') {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Surat Tugas',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: 'Nomor surat harus diisi',
          },
        })
        this.$bvModal.show('modal-generate-surat-tugas')
        return
      }

      this.isGenerating = true
      this.$bvModal.hide('modal-generate-surat-tugas')
      
      try {
        const response = await generateSuratTugas({ 
          uuid: this.selectedItem.uuid,
          nomor_surat: this.nomorSurat.trim(),
          jenis: this.selectedItem.jenis || 'penguji',
          tanggal_terbit: this.tanggalTerbit
        })
        
        if (response.data.success === true) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Surat Tugas',
              icon: 'CheckIcon',
              variant: 'success',
              text: response.data.message || 'Surat tugas berhasil di-generate',
            },
          })
          this.refetchData()
        } else {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Surat Tugas',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              text: response.data.message || 'Gagal generate surat tugas',
            },
          })
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Surat Tugas',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: 'Terjadi kesalahan saat generate surat tugas',
          },
        })
      } finally {
        this.isGenerating = false
        this.closeModalGenerate()
      }
    },
    async mulaiSidang(role, uuid){
      var data = {
        uuid: uuid,
        role: role,
      }
      const response = await postMulaiSidang(data)
      if(response.data.success === true){
        this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Jadwal Sidang',
              icon: 'CoffeeIcon',
              variant: 'success',
              text: 'Data berhasil di simpan',
            },
          })
          this.refetchData()
          this.$root.$emit('bv::hide::modal', 'modal-center-mulai-sidang'+uuid)
      }else{
        this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Jadwal Sidang',
              icon: 'CoffeeIcon',
              variant: 'danger',
              text: response.data.message,
            },
          })
      }
      this.$root.$emit('bv::hide::modal', 'modal-center-mulai-sidang'+uuid)
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'surat-tugas'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, storeModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)

    const {
      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      triggerFilter,
      dataFilter,
    } = useList()

    return {

      // Sidebar
      isAddNewUserSidebarActive,

      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      triggerFilter,
      dataFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
